import React from "react";
import SessionContext from "../contexts/SessionContext";
const useSessionContext = () => {
    const context = React.useContext(SessionContext);
    // console.log("useSessionContext context: ", context, SessionContext) ;
    if (context === undefined) {
        throw new Error("useSessionContext must be used within a SessionContextProvider");
    }
    return context;
};
export default useSessionContext;
